export default function getSale(price, oldPrice) {
    let sale = (oldPrice - price) / oldPrice * 100;
    return Math.round(sale);
}
